import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { BillingUiModule } from '@vendasta/billing-ui';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { GalaxyTooltip } from '@vendasta/galaxy/tooltip';
import { ImageTransformationModule } from '@vendasta/image-transformation';
import { UIKitModule, VaIconModule, VaImageGalleryComponent } from '@vendasta/uikit';
import { VaAddonListModule } from '../addon-list/addon-list.module';
import baseTranslation from '../assets/i18n/en_devel.json';
import { VaFaqsModule } from '../faqs/faqs.module';
import { VaFilesModule } from '../files/files.module';
import { RestrictionsModule } from '../restrictions/restrictions.module';
import { VaSellingInfoModule } from '../selling-info/selling-info.module';
import { WEBLATE_COMPONENT_NAME } from '../shared/constants';
import { AddonListComponent } from './addon-list/addon-list.component';
import { BillingPriceCardComponent } from './billing-price/billing-price-card/billing-price-card.component';
import { BillingPricingDisplayComponent } from './billing-price/billing-pricing-display/billing-pricing-display.component';
import { EditionSelectorComponent } from './edition-selector/edition-selector.component';
import { EditionsMarketingComponent } from './editions-marketing/editions-marketing.component';
import { MarketplaceCostCardComponent } from './marketplace-cost/marketplace-cost-card/marketplace-cost-card.component';
import { MpCostPricingDisplayComponent } from './marketplace-cost/mp-cost-pricing-display/mp-cost-pricing-display.component';
import { NeedHelpComponent } from './need-help/need-help.component';
import { VaProductDetailsV2Component } from './product-details-v2.component';
import { ProductInfoComponent } from './product-info/product-info.component';
import { AppProductRequirementsComponent } from './product-info/product-requirements/app-product-requirements.component';
import { RequiredProductsListComponent } from './product-info/required-products-list/required-products-list.component';
import { ScreenshotsFilesComponent } from './screenshots-files/screenshots-files.component';
import { VideosComponent } from './videos/videos.component';
import { FormPreviewDialogComponent } from './form-preview/form-preview.component';
import { VaOrderFormModule } from '../order-form/order-form.module';
import { ReactiveFormsModule } from '@angular/forms';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatChipsModule,
    MatTabsModule,
    MatSelectModule,
    MatButtonModule,
    VaSellingInfoModule,
    VaFilesModule,
    VaFaqsModule,
    VaAddonListModule,
    RestrictionsModule,
    VaImageGalleryComponent,
    MatCardModule,
    VaIconModule,
    MatBadgeModule,
    MatTooltipModule,
    ImageTransformationModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatIconModule,
    UIKitModule,
    MatMenuModule,
    MatDividerModule,
    MatDialogModule,
    GalaxyPipesModule,
    GalaxyPopoverModule,
    GalaxyTooltip,
    BillingUiModule,
    ScreenshotsFilesComponent,
    VaOrderFormModule,
    ReactiveFormsModule,
    GalaxyAlertModule,
  ],
  declarations: [
    VaProductDetailsV2Component,
    EditionSelectorComponent,
    ProductInfoComponent,
    RequiredProductsListComponent,
    NeedHelpComponent,
    EditionsMarketingComponent,
    VideosComponent,
    MarketplaceCostCardComponent,
    BillingPriceCardComponent,
    MpCostPricingDisplayComponent,
    BillingPricingDisplayComponent,
    AddonListComponent,
    AppProductRequirementsComponent,
    FormPreviewDialogComponent,
  ],
  exports: [
    VaProductDetailsV2Component,
    EditionSelectorComponent,
    MarketplaceCostCardComponent,
    BillingPriceCardComponent,
    MpCostPricingDisplayComponent,
    BillingPricingDisplayComponent,
    AddonListComponent,
    RequiredProductsListComponent,
    AppProductRequirementsComponent,
  ],
})
export class VaProductDetailsV2Module {}
